// An action for intialising brief store with initial data from server
export default function loadBriefAction(context, payload, done) {
    context.dispatch('LOAD_BRIEF', payload);
    return done();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-load.jsx